import React from "react";
import { useHistory } from "react-router-dom";
import {
  Content,
  PanelColumnSpacer,
  PanelColumn,
  PageHeadingArea,
  PanelColumnSet,
  SidebarWrapper,
  BackArrow,
  PageHeadingAreaSpacer,
  PageTitle,
} from "@backslashbuild/pp-ui";

import EpsFilter from "../modules/hmrc/EpsFilter";
import EpsTable from "../modules/hmrc/EpsTable";

export default function ViewEPSs() {
  const history = useHistory();

  return (
    <SidebarWrapper>
      <Content scrollable>
        <PageHeadingArea>
          <BackArrow onClick={() => history.goBack()} />
          <PageHeadingAreaSpacer />
          <PageTitle>Employment Payment Summaries</PageTitle>
          <PageHeadingAreaSpacer grow />
        </PageHeadingArea>
        <PanelColumnSet>
          <PanelColumn width={320}>
            <EpsFilter />
          </PanelColumn>
          <PanelColumnSpacer />
          <EpsTable />
        </PanelColumnSet>
      </Content>
    </SidebarWrapper>
  );
}
